import { FormItem } from '@framework/form';
/**
 * Componente FormItem utilizzato dai Widget.
 *
 * lasciato per eventuali modifiche di stile dedicate ai widget
 */
export const ConfigFormItem = FormItem;
